import React, { FC } from "react";
import { useFormat } from "@sinch/core/hooks/format";
import { MdsCallXs, MdsLocationOnXs, MdsMailXs } from "@sinch/icons";
import { ContactLink } from "@sinch/components/application/ContactLink/ContactLink";
import { CopyToClipboard } from "@sinch/components/CopyToClipboard/CopyToClipboard";
import { CompanyHeaderFragment } from "./fragments.types";
import { Typography } from "@mui/material";
import { rejectFalsy } from "@sinch/utils/array";
import { IconListRow } from "@sinch/components/IconListRow/IconListRow";

/**
 * Address, invoice e-mail and phone rows of a company. Every row renders only when its
 * value is filled in; e-mail and phone are copyable and open the matching handler.
 */
export const CompanyContactInfo: FC<{ company: CompanyHeaderFragment }> = ({ company }) => {
  const { phone } = useFormat();
  const { emailInvoice, phone: phoneNumber, address, city } = company;
  const fullAddress = rejectFalsy([city, address]).join(", ");

  return (
    <>
      {fullAddress !== "" && (
        <IconListRow icon={MdsLocationOnXs} iconAlign="firstLine" iconSize="xs">
          <Typography variant="descriptionSmall">
            {fullAddress}
          </Typography>
        </IconListRow>
      )}
      {emailInvoice && (
        <CopyToClipboard alwaysVisible value={emailInvoice}>
          <ContactLink href={`mailto:${emailInvoice}`} icon={MdsMailXs} label={emailInvoice} />
        </CopyToClipboard>
      )}
      {phoneNumber && (
        <CopyToClipboard alwaysVisible value={phone.national(phoneNumber)}>
          <ContactLink href={phone.uri(phoneNumber)} icon={MdsCallXs} label={phone.national(phoneNumber)} />
        </CopyToClipboard>
      )}
    </>
  );
};
